<template>
  <div class="user">
    <div class="header_wrapper bg-color-red">
      <div class="header acea-row row-between-wrapper">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="pictrue"><img :src="userInfo.avatar" /></div>
          <div class="text">
            <div class="acea-row row-middle">
              <div class="name line1">{{ userInfo.nickname }}</div>
              <div class="member acea-row row-middle" v-if="userInfo.vip">
                <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
              </div>
            </div>
            <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">
              ID：{{ userInfo.uid || 0
              }}<span class="iconfont icon-bianji1"></span>
            </router-link>
            <router-link :to="'/user/binding'" class="binding" v-else>
              <span>绑定手机号</span>
            </router-link>
          </div>
        </div>
        <span
          class="iconfont icon-shezhi"
          @click="$router.push({ path: '/user/data' })"
        ></span>
      </div>
      <div class="header_bottom acea-row">
        <!-- /user/account -->
        <router-link class="item acea-row" to="/user/user_promotion">
          <span class="num">{{ userInfo.now_money || 0 }}</span>
          <span class="text">账户余额(元)</span>
        </router-link>
        <router-link class="item acea-row" to="/user/bill/11">
          <span class="num">{{ userInfo.guquan || 0 }}</span>
          <span class="text">股权</span>
        </router-link>
        <router-link class="item acea-row" to="/user/bill/12">
          <span class="num">{{ userInfo.integral || 0 }}</span>
          <span class="text">积分</span>
        </router-link>
        <div class="item acea-row">
          <span class="num">{{ userInfo.teammoney || 0 }}</span>
          <span class="text">团队业绩</span>
        </div>
        <!-- <router-link class="item acea-row" to="/user/user_promotion">
          <span class="num">{{ userInfo.brokerage_price || 0 }}</span>
          <span class="text">红包补贴(元)</span>
        </router-link> -->
        <!-- <router-link class="item acea-row" to="/user/promoter_list">
          <span class="num">{{ userInfo.zt_num || 0 }}</span>
          <span class="text">会员人数(人)</span>
        </router-link> -->
      </div>
    </div>
    <div class="wrapper">
      <div class="spread acea-row row-between-wrapper">
        <div class="left acea-row">
          <img class="" src="@assets/images/spread_bag.png" />
          <div class="info acea-row">
            <div class="title">推广码</div>
            <div class="spread_id">{{ userInfo.uid }}</div>
          </div>
        </div>
        <router-link class="right" to="/user/user_promotion">
          立即推广
        </router-link>
      </div>
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unpaid_count > 0"
                >{{ orderStatusNum.unpaid_count }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 5 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.ptz_count > 0"
                >{{ orderStatusNum.ptz_count }}</span
              >
            </div>
            <div>拼团中</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unshipped_count > 0"
                >{{ orderStatusNum.unshipped_count }}</span
              >
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.received_count > 0"
                >{{ orderStatusNum.received_count }}</span
              >
            </div>
            <div>待收货</div>
          </router-link>
          <!-- <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated_count > 0"
                >{{ orderStatusNum.evaluated_count }}</span
              >
            </div>
            <div>待评价</div>
          </router-link> -->
          <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/images/sh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refund_count > 0"
                >{{ orderStatusNum.refund_count }}</span
              >
            </div>
            <div>未拼中</div>
          </router-link>
        </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <!--<div-->
          <!--class="item"-->
          <!--@click="changeswitch(true)"-->
          <!--v-if="userInfo.phone && isWeixin"-->
          <!--&gt;-->
          <!--<div class="pictrue"><img src="@assets/images/switch.png" /></div>-->
          <!--<div>账号切换</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <!-- <img src="@assets/images/support.png" class="support" /> -->
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>

<script>
import { getUser, getMenuUser } from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import GeneralWindow from "@components/GeneralWindow";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    GeneralWindow
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    this.User();
    this.MenuUser();
    this.isWeixin = isWeixin();
  },
  methods: {
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
        this.generalContent = {
          promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${res
            .data.promoter_price || 0}元</span>即可开通推广权限`,
          title: "您未获得推广权限"
        };
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPagey(url) {
      if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
        return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
        return (this.generalActive = true);
      }
      this.$router.push({ path: url });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      if (url === "/user/user_promotion") {
        if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
        if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
          return (this.generalActive = true);
        }
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }
      this.$router.push({ path: this.MyMenus[index].wap_url });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    }
  }
};
</script>

<style scoped lang="scss">
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}
.header_wrapper {
  width: 100%;
  height: 52.27vw;
  background-size: 100% 100%;
  .header_bottom {
    flex-wrap: nowrap;
    align-items: center;
    .item {
      width: 59%;
      text-align: center;
      flex-direction: column;
      color: #fff;
      .num {
        font-size: 4.8vw;
      }
      .text {
        font-size: 3.2vw;
      }
    }
  }
}
.wrapper {
  margin-top: -12vw;
  .spread {
    width: 94.67vw;
    height: 18.93vw;
    border-radius: 2vw;
    background-color: #fff;
    padding: 0 4vw 0 2.67vw;
    .left {
      color: #ff4142;
      img {
        width: 14.67vw;
        height: 13.33vw;
        margin-right: 5.2vw;
      }
      .info {
        flex-direction: column;
        justify-content: center;
        height: 13.33vw;
        .title {
          font-size: 3.47vw;
        }
        .spread_id {
          font-size: 4.8vw;
          font-weight: 600;
        }
      }
    }
    .right {
      display: inline-block;
      height: 8.8vw;
      width: 21.6vw;
      border-radius: 4.4vw;
      line-height: 8.8vw;
      color: #fff;
      background-color: #ff4142;
      text-align: center;
      font-style: 3.47vw;
    }
  }
}
.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
</style>
